// Single source of truth for whether third-party widgets (Tawk, Clarity, GA)
// should run. Off in local dev so we don't hit unconfigured endpoints (e.g.
// /v2/tawk/auth returns 503 locally because secure mode isn't set up).
// Forced on with VITE_ENABLE_THIRD_PARTY_SCRIPTS=true for testing the widgets.
const isLocalBrowser =
    typeof window !== "undefined" &&
    ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

export const thirdPartyScriptsEnabled =
    import.meta.env.VITE_ENABLE_THIRD_PARTY_SCRIPTS === "true" ||
    (import.meta.env.PROD && !isLocalBrowser);
